import { FC } from "react";

interface BigRightArrowProps {
  disabled?: boolean;
}

const BigRightArrow: FC<BigRightArrowProps> = ({ disabled = false }) => {
  return (
    <>
      <svg
        className="desktop-w-25px"
        width="35"
        height="36"
        viewBox="0 0 35 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6973 27.7814C20.1278 27.2119 20.1278 26.2885 20.6973 25.719L26.9577 19.4585L4.22844 19.4585C3.42303 19.4585 2.77011 18.8056 2.77011 18.0002C2.77011 17.1947 3.42303 16.5418 4.22844 16.5418L26.9577 16.5418L20.6973 10.2814C20.1278 9.71184 20.1278 8.78847 20.6973 8.21896C21.2668 7.64945 22.1902 7.64945 22.7597 8.21897L31.5096 16.969C32.0791 17.5385 32.0791 18.4618 31.5096 19.0314L22.7597 27.7814C22.1902 28.3509 21.2668 28.3509 20.6973 27.7814Z"
          fill={disabled ? "#BDBDBD" : "black"}
        />
      </svg>
    </>
  );
};

export default BigRightArrow;